import Conf from '@src/common/conf';
// import appLogger from '@public/log/monitor';
import client from '@/store/client';
import globalStore from '@/store/global';
import { SVGPureIcon } from '@/ui';

import './index.scss'
const LinkSpan = (props) => {
  const {
    title, 
    href,
    onClick = () => {},
  } = props;

  return (
    <span className={[globalStore.isDark ? 'text-[rgba(255,255,255,0.3)]' : "text-[rgba(0,0,0,0.5)] hover:text-[#000]"]}>
      <a
        className="hover:underline whitespace-nowrap"
        style={{color: 'inherit'}}
        target="_blank"
        href={href}
        onClick={onClick}
      >
        {title}
      </a>
    </span>
  )
}

const Footer = ({
  className,
  textcolor = '#A6A7AB',
}) => {

  return client.isLLQ ? null : (
    <div className={`home-footer w-ful h-full flex items-center justify-center gap-40px text-12px flex-shrink-0 ${className}`} style={{ color: textcolor }}>
      <LinkSpan 
        title='使用协议' 
        href={`/agreements/protocol`} 
        onClick={() => {
          // appLogger.logWithRouter({
          //   key : "aiso_public",
          //   action : "click",
          //   arrt : "user_pop_protocols",
          // });
        }} 
      />
      <LinkSpan 
        title='隐私条款' 
        href={`/agreements/privacy`}
        onClick={() => {
          // appLogger.logWithRouter({
          //   key : "aiso_public",
          //   action : "click",
          //   arrt : "user_pop_private",
          // });
        }} 
      />
      <LinkSpan title={`津公网安备${Conf.companyInfo.recordcode}号`} href={`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${Conf.companyInfo.recordcode}`} />
      <LinkSpan title={`津ICP备${Conf.companyInfo.icpcode}`} href="https://beian.miit.gov.cn/" />
      <LinkSpan 
        title='工商营业执照' 
        href='/agreements/license' 
        onClick={() => {
        }} 
      />
      <div className="relative group py-12px">
        <div className="hidden group-hover:block absolute left-0 -top-65px">
          <div 
            className="p-16px rounded-8px bg-[#fff] hidden group-hover:block !cursor-default"
            style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.1)'}}
          >
            <a
              className="whitespace-nowrap hover:font-bold"
              style={{textDecoration: 'underline', color: '#000'}}
              target="_blank"
              href="https://beian.cac.gov.cn/"
            >
              网信算备110105199127801230013号
            </a>
            <div className="mt-8px">
              <a
                className="whitespace-nowrap hover:font-bold"
                style={{textDecoration: 'underline', color: '#000'}}
                target="_blank"
                href="https://www.cac.gov.cn/2024-04/02/c_1713729983803145.htm"
              >
                Tianjin-360ZhiNaoDaMoXing-20230831
              </a>
            </div>
          </div>
        </div>
        <div className={["cursor-pointer flex items-center", globalStore.isDark ? 'text-[rgba(255,255,255,0.3)]' : 'text-[rgba(0,0,0,0.5)]']}>
          备案信息
          <SVGPureIcon name="more-up" className="w-8px h-4.67px ml-8px !group-hover:rotate-180 transform" />
        </div>
      </div>
    </div>
  )
};
export default Footer;